import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from "react-router-dom";
import { CustomChip } from '../../../components/chip/Chip';
import { IconButton } from "@mui/material";


export const useGetConexionesColumns = (filters) => {

    const navigate = useNavigate();
    const asistencialDetallePath = "/asistencial/adminConexiones/detalle";

    const handleClickView = (row) => {
        const { month, year, idDelegacion } = filters || {};

        navigate(asistencialDetallePath, {
            state: {
                month,
                year,
                hc: row.hc,
                idEvaluacion: row.contrato,
                contratoFechaDesde: row.contratoFechaDesde,
                contratoFechaHasta: row.contratoFechaHasta,
                nombrePaciente: row.nombrePaciente,
                documento: row.documento,
                planDescripcion: `${row.planTipo} - ${row.plan}`,
                nombreDelegacion: '',
                idDelegacion: idDelegacion,
            },
        });
    };

    const getChipCantidadPendiente = (row) => {
        return <CustomChip label={row.cantConexionesPendiente} isYellow />;
    }

    const getChipCantidadAutorizado = (row) => {
        return <CustomChip label={row.cantConexionAutorizada} isGreen />;
    }

    const initialColumns = [
        {
            headerName: "",
            field: "action",
            flex: 45,
            sortable: false,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <IconButton onClick={() => handleClickView(row)}>
                        <VisibilityIcon />
                    </IconButton>
                );
            },
        },
        {
            flex: 100,
            field: "hc",
            headerName: "HC",
        },
        {
            flex: 120,
            field: "contrato",
            headerName: "Contrato",
        },
        {
            flex: 100,
            field: "codSAP",
            headerName: "Cod. SAP",
        },
        {
            flex: 140,
            field: "documento",
            headerName: "Documento",
        },
        {
            flex: 180,
            field: "nombrePaciente",
            headerName: "Paciente",
        },
        {
            flex: 90,
            field: "planTipo",
            headerName: "Plan tipo",
        },
        {
            flex: 250,
            field: "plan",
            headerName: "Plan",
        },
        {
            flex: 110,
            field: "cantConexionesPendiente",
            headerName: "Pendientes",
            headerAlign: "center",
            align: "center",
            renderCell: ({ row }) => getChipCantidadPendiente(row)
        },
        {
            flex: 110,
            field: "cantConexionAutorizada",
            headerName: "Autorizadas",
            headerAlign: "center",
            align: "center",
            renderCell: ({ row }) => getChipCantidadAutorizado(row)
        },
        {
            flex: 120,
            field: "cantConexionSuspendida",
            headerName: "Suspendidas",
            headerAlign: "center",
            align: "center",
        },
    ];

    const columns = useMemo(
        () => generateColumnsDefaultConfiguration(initialColumns, true),
        [filters]
    );

    return columns;
}